module.exports = __webpack_public_path__ + "img/parent-child-7.cd8d1825.png";